import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'hr-translate-span',
    templateUrl: './hr-translate-span.component.html',
})
export class HrTranslateSpanComponent implements OnInit, AfterViewInit {
    @Input() key: string;
    @Input() field: string;
    @ViewChild('mySpan') mySpan: ElementRef;
    value: string;
    translateObject: { short: string; long: string };

    constructor(private translateService: TranslateService) {}

    ngOnInit(): void {
        this.translateObject = this.translateService.instant(this.key);
        this.value = this.translateObject.long;
    }

    ngAfterViewInit(): void {
        this.setValue();
    }

    setValue() {
        const h = this.mySpan.nativeElement.offsetHeight;
        if (h > 25) {
            this.value = this.translateObject.short;
        }
    }
}
